import { FC, useMemo } from "react"

import { CartBatchIcon } from "src/components/common/icon"
import { IconButton } from "src/components/common/iconButton"
import { create } from "src/helpers/bem"
import { mergeDialog } from "src/states/dialogs"
import { useCart, useCarts } from "src/states/shop/carts"

import styles from "./ShopCartButton.module.scss"

const bem = create(styles, "ShopCartButton")

type ShopCartButtonProps = {}

export const ShopCartButton: FC<ShopCartButtonProps> = () => {
  const { products } = useCart()
  const { currentCartId } = useCarts()

  const amount = useMemo(() => {
    return products.length
  }, [products.length, currentCartId])

  const cartAmount = products.length
  return (
    <div className={bem("cart-button")}>
      <IconButton
        icon={CartBatchIcon}
        title=""
        onClick={() => mergeDialog("cartDialog", { open: true })}
      >
        <span className={bem("cart-button__amount")}>
          <span>{amount}</span>
        </span>
      </IconButton>
    </div>
  )
}
